// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconCheckmark: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="6" viewBox="0 0 8 6">
            <path
                fill="currentColor"
                d="M3.28282821,5.88217525 L7.88282145,1.25570898 C8.03902524,1.09859141 8.03902524,0.843870044 7.88282145,0.686767824 L7.31714921,0.117826666 C7.16094542,-0.0392755552 6.90766549,-0.0392755552 6.7514617,0.117826666 L2.99999209,3.89087353 L1.24851688,2.1293244 C1.0923131,1.97220683 0.839033165,1.97220683 0.682829378,2.1293244 L0.117157132,2.69826556 C-0.0390466552,2.85538312 -0.0390466552,3.11010449 0.117157132,3.26720671 L2.71715596,5.88215991 C2.87334449,6.03927747 3.12660917,6.03927747 3.28282821,5.88217525 Z"
            />
        </svg>
    );
};

export default React.memo(IconCheckmark);
